module.exports = __webpack_public_path__ + "img/pitch_play_left.134b2fb9.jpg";